import React, { useEffect } from "react";
import style from "./survey.module.css";
import WelcomePage from "../../components/mis-survey/sections/welcome/WelcomePage";
import Demographics from "../../components/mis-survey/sections/Demographics";
import Feedback from "../../components/mis-survey/sections/Feedback";
import Treatment from "../../components/mis-survey/sections/Treatment";
import { useSurveySectionContent } from "../../context/survey-track/SurveySectionContext";
import { misSurveySection } from "../../utils/constants";
import Prevention from "../../components/mis-survey/sections/Prevention";
import Thankyou from "../../components/mis-survey/sections/thank-you/Thankyou";
import { useLocation } from "react-router-dom";
import MISSurveyCall from "../../components/mis-survey/call-center/MISSurveyCall";
import useCheckSource from "../../utils/useCheckSource";

const MISSurvey = () => {
	const { currentSurveySection, dispatch } = useSurveySectionContent();
	const location = useLocation();
    const { isCallCenterPortal } = useCheckSource()


	useEffect(() => {
		dispatch({
			type: "UPDATE",
			payload: {
				currentSection: null,
				showConfetti: false,
				formCompletedAt: null,
			},
		});

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location]);


	return (
		<>
			{!isCallCenterPortal && (
				<section className={style.survey_container}>
					{!currentSurveySection?.currentSection && <WelcomePage />}

					{currentSurveySection?.currentSection ===
						misSurveySection.DEMOGRAPHICS && <Demographics />}

					{currentSurveySection?.currentSection ===
						misSurveySection.PREVENTION && <Prevention />}

					{currentSurveySection?.currentSection ===
						misSurveySection.TREATMENT && <Treatment />}

					{currentSurveySection?.currentSection ===
						misSurveySection.FEEDBACK && <Feedback />}

					{currentSurveySection?.currentSection ===
						misSurveySection.THANK_YOU && <Thankyou />}
				</section>
			)}

			{isCallCenterPortal && (
				<section className={style.survey_container}>
					<MISSurveyCall />
				</section>
			)}
		</>
	);
};

export default MISSurvey;
